module.exports = "/_next/static/images/f67ef93548766c76336595c9299fb6bc-slide-2.png.webp";